import { Table, Tbody, Td, Thead, Tr } from "@chakra-ui/react";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { useCustomFormats } from "hooks/useCustomFormat";
import { Property } from "@common/properties/property.model";
import { DataTableRowActions } from "components/elements/Datatable/data-table-row-actions";
import { ThCheckbox } from "components/elements/Datatable/data-table-th-checkbox";
import { TdCheckbox } from "components/elements/Datatable/data-table-td-checkbox";
import { ThSorter } from "components/elements/Datatable/data-table-th-sorter";
import { DataTableRowSkeleton } from "components/elements/Datatable/data-table-row-skeleton";
import { Link } from "react-router-dom";
import { ThActions } from "components/elements/Datatable/data-table-th-actions";

export function PropertiesTable() {
  const { formatDate, formatDateTime } = useCustomFormats();
  const { data: result, isFetching, modal } = useResource<Property>();

  return (
    <Table variant="simple">
      <Thead>
        <Tr>
          <ThCheckbox />
          <ThSorter field="name">Property Name</ThSorter>
          <ThSorter field="address">Property Address</ThSorter>
          <ThSorter field="purchase_date" w="150px">
            Purchase Date
          </ThSorter>
          <ThSorter field="completion_date" w="150px">
            Completion Date
          </ThSorter>
          <ThSorter field="created_at" w="150px">
            Created At
          </ThSorter>
          <ThActions />
        </Tr>
      </Thead>
      <Tbody>
        {isFetching ? (
          <DataTableRowSkeleton columns={7} rows={5} />
        ) : (
          result.data.map(item => (
            <Tr key={item.id} onClick={() => modal.handleOpenModal(item)} cursor="pointer">
              <TdCheckbox entity={item} />
              <Td>
                <Link
                  to={`/companies/${item.company}/properties/${item.id}`}
                  onClick={e => e.stopPropagation()}
                >
                  {item.name}
                </Link>
              </Td>
              <Td>{item.address}</Td>
              <Td>{formatDate(item.purchase_date ?? "")}</Td>
              <Td>{formatDate(item.completion_date ?? "")}</Td>
              <Td>{formatDateTime(item.created_at)}</Td>
              <Td onClick={e => e.stopPropagation()}>
                <DataTableRowActions item={item} />
              </Td>
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
}
